import React from 'react';

import { StyledTitle } from './Subtitle.styles';
import { ISubtitleProps } from './Subtitle.types';

const Subtitle = ({
  children,
  className,
  tag,
}: ISubtitleProps): JSX.Element => {
  return (
    <StyledTitle as={tag} className={className}>
      {children}
    </StyledTitle>
  );
};

export default Subtitle;
